import React, { useCallback } from 'react';
import { IFieldTypeParamsFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { useBootstrapSelector } from '../../../../redux/selectorHooks';
import TickCheckbox from '../../../../components/Checkbox/TickCheckbox';
import { CheckboxProps } from 'semantic-ui-react/dist/commonjs/modules/Checkbox/Checkbox';
import { defaultFieldTypeParams } from '../utils';
import InputField from '../../../../components/Form/InputField';
import { FieldLabel } from '../../../../components/Form';
import { CustomTypeTimezoneWrapper } from './DerivedColumnEditUI';

interface IProps {
  manualSelectColumnTypeParams: IFieldTypeParamsFieldsFragment;
  setManualSelectColumnTypeParams: (
    params: IFieldTypeParamsFieldsFragment,
  ) => void;
  readOnly?: boolean;
}

const DerivedColumnTimestampTzInput = ({
  manualSelectColumnTypeParams,
  setManualSelectColumnTypeParams,
  readOnly,
}: IProps) => {
  const defaultTz = useBootstrapSelector('defaultConfig')?.timezone;
  const useTz = manualSelectColumnTypeParams.fixedTz != null;
  const onUseTzClick = useCallback(
    (_: React.FormEvent<HTMLInputElement>, data: CheckboxProps) => {
      if (data.checked) {
        setManualSelectColumnTypeParams(
          defaultFieldTypeParams({
            fixedTz: defaultTz,
            customDefinition: manualSelectColumnTypeParams.customDefinition,
          }),
        );
      } else {
        setManualSelectColumnTypeParams(
          defaultFieldTypeParams({
            fixedTz: null,
            customDefinition: manualSelectColumnTypeParams.customDefinition,
          }),
        );
      }
    },
    [
      defaultTz,
      manualSelectColumnTypeParams.customDefinition,
      setManualSelectColumnTypeParams,
    ],
  );

  const tzName = manualSelectColumnTypeParams.fixedTz ?? defaultTz ?? '';
  const setTzName = useCallback(
    (newTz: string) => {
      setManualSelectColumnTypeParams(
        defaultFieldTypeParams({ fixedTz: newTz }),
      );
    },
    [setManualSelectColumnTypeParams],
  );

  return (
    <>
      <FieldLabel>Use Timezone</FieldLabel>
      <CustomTypeTimezoneWrapper>
        <TickCheckbox
          checked={useTz}
          onChange={onUseTzClick}
          disabled={readOnly}
        />
        {useTz && (
          <div>
            <InputField
              autoComplete="off"
              name="tzname"
              value={tzName}
              onChange={setTzName}
              placeholder={'Enter valid timezone name'}
              disabled={readOnly}
            />
          </div>
        )}
      </CustomTypeTimezoneWrapper>
    </>
  );
};

export default DerivedColumnTimestampTzInput;
